module.exports = __webpack_public_path__ + "static/media/team-member.3c9dd123.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/services/team-member.svg
// module id = 1237
// module chunks = 0